<template>
  <div>
    <v-dialog v-model="dialog" max-width="600" persistent scrollable>
      <v-form @submit.prevent="addMeal" ref="form">
        <v-card>
          <v-card-title>Add Meal</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    required
                    label="Meal Name"
                    hide-details="auto"
                    v-model="form.name"
                    :error-messages="form.$getError('name')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    required
                    persistent-hint
                    type="number"
                    hint="in minutes"
                    label="Preparation Time"
                    hide-details="auto"
                    v-model="form.prep_time"
                    :error-messages="form.$getError('prep_time')"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    required
                    persistent-hint
                    type="number"
                    hint="in minutes"
                    label="Cooking Time"
                    hide-details="auto"
                    v-model="form.cook_time"
                    :error-messages="form.$getError('cook_time')"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    required
                    min="1"
                    max="999"
                    type="number"
                    label="Serving Quantity"
                    hide-details="auto"
                    v-model="form.serving_quantity"
                    :error-messages="form.$getError('serving_quantity')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <slot>
              <v-btn @click="closeDialog" text>Cancel</v-btn>
              <v-btn type="submit" color="primary" :loading="form.$busy"
                >Submit</v-btn
              >
            </slot>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text @click="snackbar.show = false" v-bind="attrs">OK</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Form from '@/utils/form'
import Meal from '@/models/Meal'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialog: this.value,
      form: new Form({
        name: null,
        prep_time: 0,
        cook_time: 0,
        serving_quantity: 1
      }),
      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  methods: {
    addMeal() {
      this.form.$busy = true
      this.form.$clearErrors()
      new Meal(this.form.$data())
        .save()
        .then(res => {
          this.$router.replace(`/meals/${res.id}`)
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
        .finally(() => (this.form.$busy = false))
    },

    closeDialog() {
      this.dialog = false
      this.$refs.form.reset()
      this.form.$clearErrors()
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  },

  watch: {
    dialog(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.dialog = val
    }
  }
}
</script>
